import React, { JSX } from 'react';
import { PostMessageRequest } from '@/model/PostMessageRequest';
import { Tip } from '../Tip/Index';

interface Props {
  postMessageRequest?: PostMessageRequest;
  nextScreen: () => void;
}

export const FaceLivenessInstructions: React.FC<Props> = ({
  nextScreen,
  postMessageRequest,
}): JSX.Element => (
  <div className="event w-full container mx-auto lg">
    <div className="flex flex-col items-center text-center">
      <div className="mb-3 inline-flex h-14 w-14 items-center justify-center rounded-full bg-purple-50">
        <svg viewBox="0 0 24 24" className="h-7 w-7">
          <circle cx="12" cy="8" r="3" />
          <path
            d="M4 19c1.5-3.5 4.5-5 8-5s6.5 1.5 8 5"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
          />
        </svg>
      </div>

      <h2 className="text-lg font-semibold">Antes de começar a verificação facial</h2>
      <p className="mt-1 text-sm text-gray-600">
        Para aumentar as chances de aprovação, siga as instruções abaixo:
      </p>
    </div>

    <div className="mt-4 grid grid-cols-2 gap-3">
      <Tip
        icon="💡"
        title="Boa iluminação"
        text="Fique de frente para a luz (evite luz atrás de você)."
      />
      <Tip icon="🧢" title="Sem acessórios" text="Remova boné, óculos escuros e máscaras." />
      <Tip
        icon="📱"
        title="Enquadre o rosto"
        text="Centralize o rosto e mantenha o celular na altura dos olhos."
      />
      <Tip icon="🧍" title="Fundo neutro" text="Prefira um fundo liso e sem estampas." />
      <Tip
        icon="🎥"
        title="Movimentos"
        text="Siga os movimentos solicitados (ex.: olhar para os lados)."
      />
      <Tip icon="🔇" title="Ambiente calmo" text="Evite tremer; segure firme o aparelho." />
    </div>

    <button
      onClick={nextScreen}
      className="mt-6 w-full rounded-xl bg-gray-600 py-3 text-white transition hover:bg-gray-700 active:scale-[0.99]"
      disabled={postMessageRequest === undefined}
    >
      Começar
    </button>
  </div>
);
